import { render, staticRenderFns } from "./Woods.vue?vue&type=template&id=7cfebd18"
import script from "./Woods.vue?vue&type=script&lang=js"
export * from "./Woods.vue?vue&type=script&lang=js"
import style0 from "./Woods.vue?vue&type=style&index=0&id=7cfebd18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports